__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-12-1773313707-stable-dev/";